export const GET_AUTH = 'GET_AUTH'
export const GET_USER = 'GET_USER'
export const GET_CUSTOMERS_LIST = 'GET_CUSTOMERS_LIST'
export const GET_SELECTED_CUSTOMER = 'GET_SELECTED_CUSTOMER'
export const GET_CUSTOMER_NAME = 'GET_CUSTOMER_NAME'
